import { first } from 'rxjs';
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { JEService } from 'src/app/services/je-services.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { environment } from 'src/environments/environment';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { FarmerLandDetailService } from 'src/app/services/farmer-land-detail.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';

@Component({
  selector: 'app-basic',
  templateUrl: './basic.component.html',
  styleUrls: ['./basic.component.scss']
})
export class BasicComponent implements OnInit {

  basicDetailsForm: FormGroup;
  isSubmitted = false;
  autoId: any;
  physicalVerficationApplicationData: any;
  public autoResize: boolean = true;
  longPosition: any;
  latPosition: any;
  editBilledData: boolean = false;
  // preEstimationGeolocationsArray: any = []
  jegeolocationsarray: any[] = []
  xengeolocationsarray: any = []
  sdogeolocationsarray: any = []
  mapEnable = false;
  mapEnableSDO = false;
  coordinateError: any
  preEstimationMapoverlays: any = [];
  jeMapoverlays: any = [];
  jeMapoptions: any;
  xenMapoverlays: any = [];
  xenMapoptions: any;
  sdoMapoverlays: any = [];
  sdoMapoptions: any;
  preEstimateMapoptions: any;
  preEstimateCoordinates: any = [];
  coordinatesVerified = false
  jeLogin = false
  xenLogin = false
  jeorxenLogin = false
  dimicadaLogin = false
  ddAssociateLogin = false
  selectedSurveyType: any;
  preEstimationDate: any;
  landArea: number;
  preEstSurveyLandArea: number;
  jeSurveyLandArea: number;
  xenSurveyLandArea: number;
  sdoSurveyLandArea: number;
  userID: any;
  cropTypeList: any[];
  cropBasedNames: any;

  selectedRPType: any;

  isGPSError: boolean = false;
  public sdoLogin: boolean = false;

  public mapEnableJE: boolean = false;
  public mapEnableXEN: boolean = false;

  public refreshLocation: any;
  public snapAppId: any;
  public applicationDetails: any = null;
  public isAppDetails1Loading: boolean = true;
  public isAppDetails2Loading: boolean = true;

  public existingMIDetails: any = [];

  public selLandForOwnerdetails: any = {};
  public kewatNo: any = null;

  public displayLandOwnerDialog: boolean = false;
  public landOwnerDetails : any = [];
  public showLandOwnerDetails: boolean = false;

  public isLandOwnerDetFetching: boolean = false;
  loadingText: string = 'Fetching Owner Details from Land Revenue Department';
  private dotCount: number = 0;
  private maxDots: number = 3;
  private interval: any;

  public landOwnerDetailsErrorMsg: any = null;
  public showHiddenButton: boolean = false;
  public request1complete: boolean = false;
  public request2complete: boolean = false;
  public landDetailedInfo: any = [];
  public userRole: any = null;

  constructor(
    private _fb: FormBuilder,
    private route: ActivatedRoute,
    private flService: FarmerLandDetailService,
    private router: Router,
    private cryptoJsService: CryptoJsService,
    private jeService: JEService,
    private messageService: MessageService,
    private loader: AppLoaderService,
    private activityRecordService: ActivityRecordService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
    private _dashboardService: DashboardService,
    private vendorService: VendorDashboardService
  ) {
    const tokenData = sessionStorage.getItem('token')
      ? JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')))
      : {};
    if (tokenData && (tokenData.role == 'JE' || tokenData.role == 'CJE')) {
      this.jeLogin = true
      this.jeorxenLogin = true
      sessionStorage.setItem('jecoordinatesVerified', JSON.stringify(false));
      sessionStorage.setItem('myPhysicalSurveyType', JSON.stringify(1));
    }
    if (tokenData && (tokenData.role == 'XEN')) {
      this.xenLogin = true
      this.jeorxenLogin = true
      sessionStorage.setItem('myPhysicalSurveyType', JSON.stringify(0));
      sessionStorage.setItem('xencoordinatesVerified', JSON.stringify(false));
    }
    if (tokenData && (tokenData.role == 'SDO' || tokenData.role == 'SDO')) {
      this.sdoLogin = true
      this.jeorxenLogin = false;
      sessionStorage.setItem('myPhysicalSurveyType', JSON.stringify(0));
      sessionStorage.setItem('xencoordinatesVerified', JSON.stringify(false));
    }
    if (tokenData && tokenData.role == 'DMICADA') {
      this.dimicadaLogin = true
    }
    if (tokenData && tokenData.role == 'DD Associate') {
      this.ddAssociateLogin = true
    }

  }

  ngOnInit(): void {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    this.userRole = tokenInfo['role'] ? tokenInfo['role'] : null;
    const editBilledData = loginDetails.get('editBilledData') ? loginDetails.get('editBilledData') : 'No';


    this.editBilledData = editBilledData == 'Yes' ? true : false;


    const tokenData = sessionStorage.getItem('token')
      ? JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')))
      : {};

    sessionStorage.removeItem('isRPCase');
    this.getCorpType();
    // if (sessionStorage.getItem('miPhysicalApplicationData')) {
    //   sessionStorage.removeItem('miPhysicalApplicationData');
    // }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    // if(environment.production == false){
    // }
    // else if(environment.production == true){
    // }
    sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
    // this.jegeolocationsarray  = [];
    this.selectedSurveyType = 0
    this.jeMapoptions = {
      center: { lat: 29.0588, lng: 76.0856 },
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    this.xenMapoptions = {
      center: { lat: 29.0588, lng: 76.0856 },
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    this.sdoMapoptions = {
      center: { lat: 29.0588, lng: 76.0856 },
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    this.preEstimateMapoptions = {
      center: { lat: 29.0588, lng: 76.0856 },
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    if (this.jeLogin) {
      this.refreshLocation = setInterval(() =>
        this.onRefreshCurrentLocation('jeLogin'), 5000);
    }

    if(!(tokenData.role == 'DMICADA' || tokenData.role == 'DD Associate')){
      this.getGPSCoordinates();
    }

    this.basicDetailsForm = this._fb.group({
      cropType: [null],
      cropId: [null],
      farmersName: ['', Validators.required],
      MIArea: ['', [Validators.required, Validators.min(1), (control: AbstractControl) => Validators.max(this.landArea)(control)]],
    });

    this.route.queryParams.subscribe((params) => {
      this.autoId = this.cryptoJsService.DecryptData(params.autoId);
      this.snapAppId = this.cryptoJsService.DecryptData(params.appId);
      
      if (tokenData && (tokenData.role == 'DMICADA' || tokenData.role == 'DD Associate')){
        this.getApplicationDetails(this.snapAppId);
        this.getExistingMIDetails(this.snapAppId);
      }else{
        this.isAppDetails2Loading = false;
      }

      if (this.autoId) {
        // console.log("AutoId", this.autoId);
        // console.log("appId", this.snapAppId);

        if(sessionStorage.getItem('miPhysicalApplicationData')){
          if(JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AutoId == this.autoId){
            const appData = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));
            // console.log('appData from session', appData);
            this.populateAppData(appData);
          }
          else{
            sessionStorage.removeItem('miPhysicalApplicationData');
            this.loadNewAppData();
          }
        } else{
          sessionStorage.removeItem('miPhysicalApplicationData');
          this.loadNewAppData();
        }
        // if ((JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AutoId) == this.autoId) {
        //   this.physicalVerficationApplicationData = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));
        //   this.setupGeoLocations(this.physicalVerficationApplicationData)
        // } else {
        
        // }
      } else {
        // this.loader.close();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be empty' });
        return;
      }

    }
    );
  }

  loadNewAppData(){
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);

    this.loader.start();
    this.isAppDetails1Loading = true;
    this.jeService
      .getApplicationDataForPhysicalVerification(
        this.autoId,
        JSON.parse(payload)?.sub
      )
      .pipe(first())
      .subscribe({
        next: (data: any) => {
          this.populateAppData(data);
          if(!this.isAppDetails2Loading){
            this.loader.close();
          }
          this.isAppDetails1Loading = false;
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: `Data error! Physical Applications not loaded. ${err}` });
          // this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Taken', this.autoId, new Date(), err);

          setTimeout(() => {
            history.back();
          }, 1500)
          
          if(!this.isAppDetails2Loading){
            this.loader.close();
          }
          this.isAppDetails1Loading = false;
        }
      });
  }

  populateAppData(data){
    // console.log('data', data)
    if(!this.isAppDetails2Loading){
        this.loader.close();
      }
      this.isAppDetails1Loading = false;
      // this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Taken', this.autoId, new Date(), 'Success');
      let Obj = {};
      if (
        sessionStorage.getItem('myPhysicalSurveyType') &&
        JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))
          ?.AutoId == this.autoId
      ) {
        this.selectedSurveyType = sessionStorage.getItem(
          'myPhysicalSurveyType'
        );
      } else if (data.SurveyType) {
        this.selectedSurveyType = data.SurveyType;
        if (this.selectedSurveyType == 1) {
          let val = '';
          if(this.xenLogin){
            val = 'xenLogin'
          }else if(this.sdoLogin){
            val = 'sdoLogin'
          }
          this.refreshLocation = setInterval(() => {
            this.onRefreshCurrentLocation(val);
          }, 5000);
        }
        sessionStorage.setItem(
          'myPhysicalSurveyType',
          JSON.stringify(this.selectedSurveyType)
        );
      }
      this.physicalVerficationApplicationData = data;
      this.landArea = data?.MIArea;

      if (data?.CropTypeId_PhySurvey && data?.CropTypeId_PhySurvey != 0) {
        this.basicDetailsForm.controls.cropType.setValue(data?.CropTypeId_PhySurvey);
        this.getCropTypeName({ value: data?.CropTypeId_PhySurvey }, data?.CropId_PhySurvey);
        // this.basicDetailsForm.controls.cropId.setValue(data?.CropId_PhySurvey);
      }
      if (this.jeLogin || ((this.xenLogin || this.sdoLogin) && data?.SurveyType == 1)) {
        this.basicDetailsForm.controls['cropType'].clearValidators();
        this.basicDetailsForm.controls['cropId'].clearValidators();
        this.basicDetailsForm.controls['cropType'].setValidators(Validators.required);
        this.basicDetailsForm.controls['cropId'].setValidators(Validators.required);
      }
      this.basicDetailsForm.controls['cropType'].updateValueAndValidity();
      this.basicDetailsForm.controls['cropId'].updateValueAndValidity();

      if ((this.ddAssociateLogin || this.dimicadaLogin) && sessionStorage.getItem('PVModifiedLandArea') && JSON.parse(sessionStorage.getItem('PVModifiedLandArea'))?.autoId == this.autoId) {
        let val = JSON.parse(sessionStorage.getItem('PVModifiedLandArea'))?.MIArea;
        if (!(val == null || val == "")) {
          this.basicDetailsForm.controls.MIArea.setValue(val);
        } else {
          this.basicDetailsForm.controls.MIArea.setValue(data?.MIArea);
        }
      }
      else {
        this.basicDetailsForm.controls.MIArea.setValue(data?.MIArea);
      }
      sessionStorage.setItem('miPhysicalApplicationData', JSON.stringify(data));
      Obj['listGPSCoordinatesPreEst'] = data.listGPSCoordinatesPreEst
      if (sessionStorage.getItem('miPhysicalAppJEGPSCoordinates') &&
        JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AutoId == this.autoId
        && JSON.parse(sessionStorage.getItem('miPhysicalAppJEGPSCoordinates'))) {
        Obj['listGPSCoordinatesJE'] = JSON.parse(sessionStorage.getItem('miPhysicalAppJEGPSCoordinates'))
      } else {
        Obj['listGPSCoordinatesJE'] = data.listGPSCoordinatesJE
      }
      if (sessionStorage.getItem('miPhysicalAppSDOGPSCoordinates')
        && JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AutoId == this.autoId &&
        JSON.parse(sessionStorage.getItem('miPhysicalAppSDOGPSCoordinates'))) {
        Obj['listGPSCoordinatesSDO'] = JSON.parse(sessionStorage.getItem('miPhysicalAppSDOGPSCoordinates'))
      } else {
        Obj['listGPSCoordinatesSDO'] = data.listGPSCoordinatesSDO
      }
      if (sessionStorage.getItem('miPhysicalAppXENGPSCoordinates')
        && JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AutoId == this.autoId &&
        JSON.parse(sessionStorage.getItem('miPhysicalAppXENGPSCoordinates'))) {
        Obj['listGPSCoordinatesXEN'] = JSON.parse(sessionStorage.getItem('miPhysicalAppXENGPSCoordinates'))
      } else {
        Obj['listGPSCoordinatesXEN'] = data.listGPSCoordinatesXEN
      }
      this.setupGeoLocations(Obj)
      this.preEstimationDate = new Date(data?.PreEstDate ? data?.PreEstDate : "01-01-01")
  }

  get basicDetailsFormControls() {
    return this.basicDetailsForm.controls;
  }

  onRefreshCurrentLocation(loginType) {
    if (loginType == 'xenLogin') {
      this.xenMapoverlays.forEach((val, index) => {
        if (val?.title == "Current Location") {
          this.xenMapoverlays.splice(index, 1);
        }
      })
      this.getCurrentLocation(loginType);
    }
    if (loginType == 'sdoLogin') {
      this.sdoMapoverlays.forEach((val, index) => {
        if (val?.title == "Current Location") {
          this.sdoMapoverlays.splice(index, 1);
        }
      })
      this.getCurrentLocation(loginType);
    }
    else {
      this.jeMapoverlays.forEach((val, index) => {
        if (val?.title == "Current Location") {
          this.jeMapoverlays.splice(index, 1);
        }
      })
      this.getCurrentLocation(loginType);
    }
  }

  getCurrentLocation(loginType) {
    let overlay;
    if (loginType == 'xenLogin') {
      overlay = this.xenMapoverlays;
    }
    else if (loginType == 'sdoLogin') {
      overlay = this.sdoMapoverlays;
    }
    else {
      overlay = this.jeMapoverlays;
    }

    let mapEnable = this.mapEnable;
    let instant = this;

    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      };

      function success(pos) {
        const crd = pos.coords;
        const obj = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        if (loginType == 'xenLogin') {
          instant.xenMapoptions.center = obj;
        }
        else if (loginType == 'sdoLogin') {
          instant.sdoMapoptions.center = obj;
        }
        else {
          instant.jeMapoptions.center = obj;
        }
        // const image = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';

        const currentLocationMarker = new google.maps.Marker({
          position: { lat: obj?.lat, lng: obj?.lng },
          title: 'Current Location',
          icon: '../../assets/map/location-icon-5.png',
        });

        overlay.push(currentLocationMarker)


        if (loginType == 'xenLogin') {
          instant.mapEnableXEN = true;
        }
        else if (loginType == 'sdoLogin') {
          instant.mapEnableSDO = true;
        }
        else {
          instant.mapEnableJE = true;
        }
      }

      function error(err) {
        instant.isGPSError = true;
        let detailsMsg = '';
        if (err?.message == 'User denied Geolocation') {
          detailsMsg = 'Please enable Geolocation access.'
        } else {
          detailsMsg = 'Please Refresh the Current Location.'
        }
        instant.messageService.add({
          severity: 'error',
          summary: err.message,
          detail: detailsMsg,
        });
      }

      // this.mapEnable = true;
      navigator.geolocation.getCurrentPosition(success, error, options);
      // this.addOverlay();
    }
  }

  getGPSCoordinates() {
    this._getPosition().then((pos) => {
      this.latPosition = pos.lat;
      this.longPosition = pos.lng;
    });
  }

  _getPosition(): Promise<any> {
    // this.loader.start();
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          // this.loader.close();
          resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
        },
        (err) => {
          // this.loader.close();
          // reject(err);
        }
      );
    });
  }

  onBasicDetailsFormSubmit() {
    if (sessionStorage.getItem('isRPCase') && sessionStorage.getItem('isRPCase') == 'true') {

      this.confirmationService.confirm({
        target: event.target as EventTarget,
        message: 'Are you sure that you want to proceed this App as RP case?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: "none",
        rejectIcon: "none",
        rejectButtonStyleClass: "p-button-text",
        accept: () => {
          this.route.queryParams
            .subscribe(params => {
              if (params.autoId) {
                sessionStorage.setItem('miPhysicalAppJEGPSCoordinates', JSON.stringify(this.jegeolocationsarray));
                sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
                sessionStorage.setItem('miPhysicalAppSDOGPSCoordinates', JSON.stringify(this.sdogeolocationsarray));
                this.router.navigate([this.router.url.split('/')[1], 'application', 'attachment'], { queryParams: { autoId: params.autoId, appId: params.appId } });
              } else {
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
              }
            }
            );
        },
        reject: () => {
          this.selectedRPType = [];
        }
      });

      return;
    }

    this.isSubmitted = true;
    if (this.basicDetailsFormControls?.cropId?.errors || this.basicDetailsFormControls?.cropType?.errors) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail:
          "Fill the crop details properly",
      });
      return;
    }
    if (this.basicDetailsFormControls?.MIArea?.errors) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail:
          "Fill the value of 'Area Surveyed' properly",
      });
      return;
    }
    let geoCoordinateError = false;
    if (this.jeLogin) {
      this.jegeolocationsarray.forEach((array, index) => {
        if (array.length < 4) {
          this.coordinateError = `Please provide atleast 4 GPS Coordinates for polygon ${index + 1}`;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Please provide atleast 4 GPS Coordinates for polygon ${index + 1}`,
          });
          geoCoordinateError = true;
          return;
        }
      })
      if ((Math.abs(this.landArea - this.jeSurveyLandArea) >= 0.1 * this.landArea)) {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: `Difference between Calculated Area (${this.landArea}) and Survey Area (${this.jeSurveyLandArea}) is more. Please recapture the coordinates.` });
        geoCoordinateError = true;
        return;
      }
    } else if ((this.xenLogin && this.selectedSurveyType == 1)) {
      this.xengeolocationsarray.forEach((array, index) => {
        if (array.length < 4) {
          this.coordinateError = `Please provide atleast 4 GPS Coordinates for polygon ${index + 1}`;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Please provide atleast 4 GPS Coordinates for polygon ${index + 1}`,
          });
          geoCoordinateError = true;
          return;
        }
      })
      if ((Math.abs(this.landArea - this.xenSurveyLandArea) >= 0.1 * this.landArea)) {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: `Difference between Calculated Area (${this.landArea}) and Survey Area (${this.xenSurveyLandArea}) is more. Please recapture the coordinates.` });
        geoCoordinateError = true;
        return;
      }
    } else if ((this.sdoLogin && this.selectedSurveyType == 1)) {
      this.sdogeolocationsarray.forEach((array, index) => {
        if (array.length < 4) {
          this.coordinateError = `Please provide atleast 4 GPS Coordinates for polygon ${index + 1}`;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Please provide atleast 4 GPS Coordinates for polygon ${index + 1}`,
          });
          geoCoordinateError = true;
          return;
        }
      })
      if ((Math.abs(this.landArea - this.sdoSurveyLandArea) >= 0.1 * this.landArea)) {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: `Difference between Calculated Area (${this.landArea}) and Survey Area (${this.sdoSurveyLandArea}) is more. Please recapture the coordinates.` });
        geoCoordinateError = true;
        return;
      }
    }

    let isPolygonPositionError = false;
    if (this.preEstimateCoordinates.length != 0 && this.preEstimateCoordinates[0].length != 0 && (this.jeLogin && this.preEstimationDate > new Date("03-22-23") || (this.xenLogin && this.selectedSurveyType == 1 && this.preEstimationDate > new Date("03-22-23")))) {
      let preEstimate: any = this.preEstimateCoordinates;
      const preEstimateMerge = preEstimate.flat();

      if (this.xenLogin) {
        let xenArray: any = this.xengeolocationsarray;
        const xenMergedArray = xenArray.flat();
        isPolygonPositionError = this.verifyCoordinates(preEstimateMerge, xenMergedArray, 'xenLogin');
        if (isPolygonPositionError) {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Captured GPS Coordinates are Not Matching' });
          return;
        }
      }
      else if (this.sdoLogin) {
        let sdoArray: any = this.sdogeolocationsarray;
        const sdoMergedArray = sdoArray.flat();
        isPolygonPositionError = this.verifyCoordinates(preEstimateMerge, sdoMergedArray, 'sdoLogin');
        if (isPolygonPositionError) {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Captured GPS Coordinates are Not Matching' });
          return;
        }
      }
      else {
        let jeArray: any = this.jegeolocationsarray;
        const jeMergedArray = jeArray.flat();
        isPolygonPositionError = this.verifyCoordinates(preEstimateMerge, jeMergedArray, 'jeLogin');
        if (isPolygonPositionError) {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Captured GPS Coordinates are Not Matching' });
          return;
        }
      }
    }

    if (geoCoordinateError || isPolygonPositionError) {
      // this.coordinateError = 'PLEASE_PROVIDE_ATLEAST_4_GPS_COORDINATES'
      // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please provide atleast 4 GPS Coordinates' });
      return;
    }
    // else if (this.jeLogin && this.jegeolocationsarray.length >= 4 && (Math.abs(this.landArea - this.jeSurveyLandArea) >= 0.1*this.landArea)) {
    //   this.messageService.add({ severity: 'error', summary: 'Error Message', detail: `Difference between Calculated Area (${this.landArea}) and Survey Area (${this.jeSurveyLandArea}) is more. Please recapture the coordinates.` });
    //   return;
    // } 
    // else if (this.xenLogin && this.xengeolocationsarray.length < 4 && this.selectedSurveyType == 1) {
    //   this.coordinateError = 'PLEASE_PROVIDE_ATLEAST_4_GPS_COORDINATES'
    //   this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please provide atleast 4 GPS Coordinates' });
    //   return;
    // } 

    // else if(this.preEstimateCoordinates&& this.preEstimateCoordinates.length > 0 && !this.verifyCoordinates(this.preEstimateCoordinates, this.jegeolocationsarray, false) && this.jeLogin && this.preEstimationDate > new Date("03-22-23")){
    //   this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Captured GPS Coordinates are Not Matching' });
    // }  
    // else if(this.preEstimateCoordinates&& this.preEstimateCoordinates.length > 0 && !this.verifyCoordinates(this.preEstimateCoordinates, this.xengeolocationsarray, true) && this.xenLogin && this.selectedSurveyType == 1 && this.preEstimationDate > new Date("03-22-23")){
    //   this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Captured GPS Coordinates are Not Matching' });
    // }
    else {
      if (this.xenLogin) {
        sessionStorage.setItem('xencoordinatesVerified', JSON.stringify(true));
      } else if (this.sdoLogin) {
        sessionStorage.setItem('sdocoordinatesVerified', JSON.stringify(true));
      } else {
        sessionStorage.setItem('jecoordinatesVerified', JSON.stringify(true));
      }
      //  let jegeoCoordinates = []
      // let xengeoCoordinates = []

      // for (let index = 0; index < this.jegeolocationsarray.length; index++) {
      //   const gpsObj = {
      //     "cornerID": index + 1,
      //     "latitude": this.jegeolocationsarray[index].lat,
      //     "longitude": this.jegeolocationsarray[index].lng
      //   }
      //   jegeoCoordinates.push(gpsObj);
      // }
      // for (let index = 0; index < this.xengeolocationsarray.length; index++) {
      //   const xengpsObj = {
      //     "cornerID": index + 1,
      //     "latitude": this.xengeolocationsarray[index].lat,
      //     "longitude": this.xengeolocationsarray[index].lng
      //   }
      //   xengeoCoordinates.push(xengpsObj);
      // }
      if (this.userRole == 'DD Associate') {
        this.route.queryParams
          .subscribe(params => {
            if (params.autoId) {
              sessionStorage.setItem('miPhysicalAppJEGPSCoordinates', JSON.stringify(this.jegeolocationsarray));
              sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
              sessionStorage.setItem('miPhysicalAppSDOGPSCoordinates', JSON.stringify(this.sdogeolocationsarray));
              this.router.navigate([this.router.url.split('/')[1], 'application', 'image-attachment'], { queryParams: { autoId: params.autoId, appId: params.appId } });
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
            }
          }
          );
      }
      else {
        this.route.queryParams
          .subscribe(params => {
            if (params.autoId) {
              sessionStorage.setItem('miPhysicalAppJEGPSCoordinates', JSON.stringify(this.jegeolocationsarray));
              sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
              sessionStorage.setItem('miPhysicalAppSDOGPSCoordinates', JSON.stringify(this.sdogeolocationsarray));
              this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
            }
          }
          );
      }
    }

  }

  addMarkers(row: any, index, tableNo) {
    this.jeMapoverlays.push(
      new google.maps.Marker({
        position: { lat: row?.lat, lng: row?.lng },
        title: `${row?.CornerID}`,
        draggable: false,
        // draggable: true,
        crossOnDrag: false
      })
    );
  }

  addOverlay() {
    this.jegeolocationsarray.forEach(arr => {
      this.jeMapoverlays.push(
        new google.maps.Polygon({
          paths: arr,
          strokeOpacity: 0.5,
          strokeWeight: 1,
          fillColor: '#1976D2',
          fillOpacity: 0.35,
        })
      );
    })

    setTimeout(() => this.calculateSurveyArea('jeLogin'), 1000);
  }

  xenAddOverlay() {
    this.xengeolocationsarray.forEach(arr => {
      this.xenMapoverlays.push(
        new google.maps.Polygon({
          paths: arr,
          strokeOpacity: 0.5,
          strokeWeight: 1,
          fillColor: '#1976D2',
          fillOpacity: 0.35,
        })
      );
    })

    setTimeout(() => this.calculateSurveyArea('xenLogin'), 1000);
  }
  xenAddMarkers(row: any, index, tableNo) {
    this.xenMapoverlays.push(
      new google.maps.Marker({
        position: { lat: row?.lat, lng: row?.lng },
        title: `${row?.CornerID}`,
        draggable: false,
        // draggable: true,
        crossOnDrag: false
      })
    );
  }

  sdoAddOverlay() {
    this.sdogeolocationsarray.forEach(arr => {
      this.sdoMapoverlays.push(
        new google.maps.Polygon({
          paths: arr,
          strokeOpacity: 0.5,
          strokeWeight: 1,
          fillColor: '#1976D2',
          fillOpacity: 0.35,
        })
      );
    })

    setTimeout(() => this.calculateSurveyArea('sdoLogin'), 1000);
  }
  sdoAddMarkers(row: any, index, tableNo) {
    this.sdoMapoverlays.push(
      new google.maps.Marker({
        position: { lat: row?.lat, lng: row?.lng },
        title: `${row?.CornerID}`,
        draggable: false,
        // draggable: true,
        crossOnDrag: false
      })
    );
  }

  calculateSurveyArea(val) {
    let area = 0;
    if (val == 'xenLogin') {
      this.xengeolocationsarray.forEach(array => {
        if (array.length >= 3) {
          let polygon = new google.maps.Polygon({ paths: array });
          area += this.calculateLandArea(polygon.getPath());
        }
      });
      this.xenSurveyLandArea = Number((0.000247105 * area).toFixed(2));

    } else if (val == 'sdoLogin') {
      this.sdogeolocationsarray.forEach(array => {
        if (array.length >= 3) {
          let polygon = new google.maps.Polygon({ paths: array });
          area += this.calculateLandArea(polygon.getPath());
        }
      });
      this.sdoSurveyLandArea = Number((0.000247105 * area).toFixed(2));

    } else {
      this.jegeolocationsarray.forEach(array => {
        if (array.length >= 3) {
          let polygon = new google.maps.Polygon({ paths: array });
          area += this.calculateLandArea(polygon.getPath());
        }
      });
      this.jeSurveyLandArea = Number((0.000247105 * area).toFixed(2));
    }
  }

  calculateLandArea(polygon) {
    return google?.maps?.geometry?.spherical.computeArea(polygon)
  }

  preEstimationAddOverlay() {
    this.preEstimateCoordinates.forEach((array) => {
      this.preEstimationMapoverlays.push(new google.maps.Polygon({
        paths: array,
        strokeOpacity: 0.5, strokeWeight: 1, fillColor: '#1976D2', fillOpacity: 0.35
      }))
    })

    setTimeout(() => this.calSurveyAreaPreEst(), 1000);
    // this.preEstimationMapoverlays.push(new google.maps.Polygon({
    //   paths: this.preEstimationGeolocationsArray,
    //   strokeOpacity: 0.5, strokeWeight: 1, fillColor: '#1976D2', fillOpacity: 0.35
    // }))
  }

  calSurveyAreaPreEst() {
    let area = 0;
    this.preEstimateCoordinates.forEach(array => {
      if (array.length >= 3) {
        let polygon = new google.maps.Polygon({ paths: array });
        area += this.calculateLandArea(polygon.getPath());
      }
    });
    this.preEstSurveyLandArea = Number((0.000247105 * area).toFixed(2));
  }

  preEstimationAddMarkers(row: any, index) {
    this.preEstimationMapoverlays.push(new google.maps.Marker({
      position: { lat: row?.lat, lng: row?.lng },
      title: row?.CornerID
    }))
  }

  onCapture(val, index) {
    this.cdr.detectChanges();
    let instant = this;
    this.coordinateError = ''
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };

      function success(pos) {
        let isExist = false
        if (val == 'xenLogin') {
          isExist = instant.xengeolocationsarray[index].find(data => {
            if (
              data.latitude == pos.coords.latitude &&
              data.longitude == pos.coords.longitude) {
              return data
            }
          })
        }
        else if (val == 'sdoLogin') {
          isExist = instant.sdogeolocationsarray[index].find(data => {
            if (
              data.latitude == pos.coords.latitude &&
              data.longitude == pos.coords.longitude) {
              return data
            }
          })
        }
        else {
          isExist = instant.jegeolocationsarray[index].find((data) => {
            if (
              data.latitude == pos.coords.latitude &&
              data.longitude == pos.coords.longitude
            ) {
              return data;
            }
          });
        }
        if (isExist) {
          instant.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please move to a different location to get new coordinates.' });
        } else {
          const obj = {
            CornerID: val == 'xenLogin' ? `Polygon  ${index + 1} : Coordinate  ${instant.xengeolocationsarray[index].length + 1}` : val == 'sdoLogin' ? `Polygon  ${index + 1} : Coordinate  ${instant.sdogeolocationsarray[index].length + 1}` : `Polygon  ${index + 1} : Coordinate  ${instant.jegeolocationsarray[index].length + 1}`,
            cornerID: val == 'xenLogin' ? `Polygon  ${index + 1} : Coordinate  ${instant.xengeolocationsarray[index].length + 1}` : val == 'sdoLogin' ? `Polygon  ${index + 1} : Coordinate  ${instant.sdogeolocationsarray[index].length + 1}` : `Polygon  ${index + 1} : Coordinate  ${instant.jegeolocationsarray[index].length + 1}`,
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude
          }
          val == 'xenLogin' ? instant.xengeolocationsarray[index].push(obj) : val == 'sdoLogin' ? instant.sdogeolocationsarray[index].push(obj) : instant.jegeolocationsarray[index].push(obj)

          // Check for self-intersections before allowing the polygon creation
          if (instant.isSelfIntersecting(val == 'xenLogin' ? instant.xengeolocationsarray[index] : val == 'sdoLogin' ? instant.sdogeolocationsarray[index] : instant.jegeolocationsarray[index])) {
            // this.onDelect(this.geolocationsarray.length - 1);
            val == 'xenLogin' ? instant.xengeolocationsarray[index].pop() : val == 'sdoLogin' ? instant.sdogeolocationsarray[index].pop() : instant.jegeolocationsarray[index].pop()
            alert('Polygon is invalid due to intersecting edges. Please redraw.');
            return;
          } else {
            instant.onSave(val, index);
          }
        }
      }

      function error(err) {
      }
      navigator.geolocation.getCurrentPosition(success, error, options);
    }

  }

  // onDrag(event) {
  //   let index = -1;
  //   index = event?.overlay?.title ? event?.overlay?.title.split(' ')[1] : -1;
  //   if (index >= 1) {
  //     this.jegeolocationsarray[index - 1].lat = event?.overlay?.position?.lat();
  //     this.jegeolocationsarray[index - 1].lng = event?.overlay?.position?.lng();

  //     this.removeOverlay();
  //     this.addOverlay();
  //   }
  // }

  onDrag(val, event) {
    if (val == 'xenLogin') {
      let indexVal = this.getTableAndCoordinateVal(val, event?.overlay?.title)
      let index = indexVal?.coordinateValue ? indexVal?.coordinateValue : 1;
      let tableNo = indexVal?.polygonIndex ? indexVal?.polygonIndex : 1;

      if (index >= 1) {
        this.xengeolocationsarray[tableNo - 1][index - 1].lat = event?.overlay?.position?.lat();
        this.xengeolocationsarray[tableNo - 1][index - 1].latitude = event?.overlay?.position?.lat();
        this.xengeolocationsarray[tableNo - 1][index - 1].lng = event?.overlay?.position?.lng();
        this.xengeolocationsarray[tableNo - 1][index - 1].longitude = event?.overlay?.position?.lng();

        this.xenRemoveOverlay();
        this.xenAddOverlay();
        // this.removeOverlay();
        // this.addOverlay();
      }

    } else if (val == 'sdoLogin') {
      let indexVal = this.getTableAndCoordinateVal(val, event?.overlay?.title)
      let index = indexVal?.coordinateValue ? indexVal?.coordinateValue : 1;
      let tableNo = indexVal?.polygonIndex ? indexVal?.polygonIndex : 1;

      if (index >= 1) {
        this.sdogeolocationsarray[tableNo - 1][index - 1].lat = event?.overlay?.position?.lat();
        this.sdogeolocationsarray[tableNo - 1][index - 1].latitude = event?.overlay?.position?.lat();
        this.sdogeolocationsarray[tableNo - 1][index - 1].lng = event?.overlay?.position?.lng();
        this.sdogeolocationsarray[tableNo - 1][index - 1].longitude = event?.overlay?.position?.lng();

        this.sdoRemoveOverlay();
        this.sdoAddOverlay();
        // this.removeOverlay();
        // this.addOverlay();
      }

    } else {
      let indexVal = this.getTableAndCoordinateVal(val, event?.overlay?.title)
      let index = indexVal?.coordinateValue ? indexVal?.coordinateValue : 1;
      let tableNo = indexVal?.polygonIndex ? indexVal?.polygonIndex : 1;

      if (index >= 1) {
        this.jegeolocationsarray[tableNo - 1][index - 1].lat = event?.overlay?.position?.lat();
        this.jegeolocationsarray[tableNo - 1][index - 1].latitude = event?.overlay?.position?.lat();
        this.jegeolocationsarray[tableNo - 1][index - 1].lng = event?.overlay?.position?.lng();
        this.jegeolocationsarray[tableNo - 1][index - 1].longitude = event?.overlay?.position?.lng();

        this.removeOverlay();
        this.addOverlay();
      }
    }

  }

  getTableAndCoordinateVal(loginType, val) {
    let polygonIndex = null; // Default to null if not present
    let coordinateValue = null; // Default to null if not present

    // Match both patterns
    const polygonMatch = val.match(/Polygon\s+(\d+)/);
    const coordinateMatch = val.match(/Coordinate\s+(\d+)/);

    // Extract polygon index if it exists
    if (polygonMatch) {
      polygonIndex = parseInt(polygonMatch[1], 10);
    }

    // Extract coordinate value if it exists
    if (coordinateMatch) {
      coordinateValue = parseInt(coordinateMatch[1], 10);
    }

    return { polygonIndex, coordinateValue };
  }

  removeOverlay() {
    this.jeMapoverlays.pop().setMap(null);
  }

  xenRemoveOverlay() {
    this.xenMapoverlays.pop().setMap(null);
  }

  sdoRemoveOverlay() {
    this.sdoMapoverlays.pop().setMap(null);
  }

  isSelfIntersecting(coordsArray) {
    for (let i = 0; i < coordsArray.length - 1; i++) {
      for (let j = i + 2; j < coordsArray.length; j++) {
        // Prevent checking consecutive edges or the last edge with the first one
        if (i === 0 && j === coordsArray.length - 1) continue;
        if (this.doLinesIntersect(coordsArray[i], coordsArray[i + 1], coordsArray[j], coordsArray[(j + 1) % coordsArray.length])) {
          return true;
        }
      }
    }
    return false;
  }

  doLinesIntersect(p1, q1, p2, q2) {
    // Helper function to calculate orientation of the points
    function orientation(p, q, r) {
      let val = (q.lat - p.lat) * (r.lng - q.lng) - (q.lng - p.lng) * (r.lat - q.lat);
      if (val === 0) return 0; // collinear
      return (val > 0) ? 1 : 2; // clock or counterclockwise
    }

    // Check the four orientations needed for the general and special cases
    let o1 = orientation(p1, q1, p2);
    let o2 = orientation(p1, q1, q2);
    let o3 = orientation(p2, q2, p1);
    let o4 = orientation(p2, q2, q1);

    // General case
    if (o1 !== o2 && o3 !== o4) return true;

    // Special cases
    // p1, q1, p2 are collinear and p2 lies on segment p1q1
    if (o1 === 0 && this.onSegment(p1, p2, q1)) return true;

    // p1, q1, q2 are collinear and q2 lies on segment p1q1
    if (o2 === 0 && this.onSegment(p1, q2, q1)) return true;

    // p2, q2, p1 are collinear and p1 lies on segment p2q2
    if (o3 === 0 && this.onSegment(p2, p1, q2)) return true;

    // p2, q2, q1 are collinear and q1 lies on segment p2q2
    if (o4 === 0 && this.onSegment(p2, q1, q2)) return true;

    return false;
  }

  onSegment(p, q, r) {
    return q.lng <= Math.max(p.lng, r.lng) && q.lng >= Math.min(p.lng, r.lng) &&
      q.lat <= Math.max(p.lat, r.lat) && q.lat >= Math.min(p.lat, r.lat);
  }

  // onDelect(i, xenlogin) {
  //   if(xenlogin) {
  //     this.xengeolocationsarray.splice(i, 1);
  //     for (let index = 0; index < this.xengeolocationsarray.length; index++) {
  //       this.xengeolocationsarray[index].CornerID = index + 1;
  //       this.xengeolocationsarray[index].cornerID = index + 1;
  //     }
  //     if (this.xengeolocationsarray.length == 0) {
  //       this.mapEnable = false;
  //     } else {
  //       this.xenMapoptions.center = this.xengeolocationsarray[0]
  //       this.mapEnable = false;
  //       this.mapEnable = true;
  //       this.xenMapoverlays = []
  //       this.xengeolocationsarray.forEach((row, index) => {
  //         this.xenAddMarkers(row, index,)
  //       });
  //       this.xenAddOverlay()
  //     }
  // }else {
  //     this.jegeolocationsarray.splice(i, 1);
  //     for (let index = 0; index < this.jegeolocationsarray.length; index++) {
  //       this.jegeolocationsarray[index].CornerID = index + 1;
  //       this.jegeolocationsarray[index].cornerID = index + 1;
  //     }
  //     if (this.jegeolocationsarray.length == 0) {
  //       this.mapEnable = false;
  //     } else {
  //       this.jeMapoptions.center = this.jegeolocationsarray[0]
  //       this.mapEnable = false;
  //       this.mapEnable = true;
  //       this.jeMapoverlays = []
  //       this.jegeolocationsarray.forEach((row, index) => {
  //         this.addMarkers(row, index)
  //       });
  //       this.addOverlay()
  //     }
  //   }
  //   sessionStorage.setItem('miPhysicalAppJEGPSCoordinates', JSON.stringify(this.jegeolocationsarray));
  //   sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
  // }

  onDeleteCoordinate(loginType, i, tableNo) {
    if (loginType == 'xenLogin') {
      this.xengeolocationsarray[tableNo].splice(i, 1);
      for (let index = 0; index < this.xengeolocationsarray[tableNo].length; index++) {
        this.xengeolocationsarray[tableNo][index].CornerID = `Polygon  ${tableNo + 1} : Coordinate  ${index + 1}`;
      }

      if (this.xengeolocationsarray[tableNo].length > 0) {
        this.onSave(loginType, tableNo);
      } else {
        this.onSave(loginType, 0);
      }
    }
    else if (loginType == 'sdoLogin') {
      this.sdogeolocationsarray[tableNo].splice(i, 1);
      for (let index = 0; index < this.sdogeolocationsarray[tableNo].length; index++) {
        this.sdogeolocationsarray[tableNo][index].CornerID = `Polygon  ${tableNo + 1} : Coordinate  ${index + 1}`;
      }

      if (this.sdogeolocationsarray[tableNo].length > 0) {
        this.onSave(loginType, tableNo);
      } else {
        this.onSave(loginType, 0);
      }
    }
    else {
      this.jegeolocationsarray[tableNo].splice(i, 1);
      for (let index = 0; index < this.jegeolocationsarray[tableNo].length; index++) {
        this.jegeolocationsarray[tableNo][index].CornerID = `Polygon  ${tableNo + 1} : Coordinate  ${index + 1}`;
      }

      if (this.jegeolocationsarray[tableNo].length > 0) {
        this.onSave(loginType, tableNo);
      } else {
        this.onSave(loginType, 0);
      }
    }
  }

  onDeleteNewPolygon(loginType, i) {
    if (loginType == 'xenLogin') {
      if (i >= 0 && i < this.xengeolocationsarray.length) {
        this.xengeolocationsarray.splice(i, 1);

        // Renaming the remaining polygon corner IDs
        for (let j = 0; j < this.xengeolocationsarray.length; j++) {
          for (let k = 0; k < this.xengeolocationsarray[j].length; k++) {
            this.xengeolocationsarray[j][k].CornerID = `Polygon ${j + 1} : Coordinate ${k + 1}`;
          }
        }

        this.onSave(loginType, 0);

      } else {
        // console.error("Index out of bounds");
      }
    }
    else if (loginType == 'sdoLogin') {
      if (i >= 0 && i < this.sdogeolocationsarray.length) {
        this.sdogeolocationsarray.splice(i, 1);

        // Renaming the remaining polygon corner IDs
        for (let j = 0; j < this.sdogeolocationsarray.length; j++) {
          for (let k = 0; k < this.sdogeolocationsarray[j].length; k++) {
            this.sdogeolocationsarray[j][k].CornerID = `Polygon ${j + 1} : Coordinate ${k + 1}`;
          }
        }

        this.onSave(loginType, 0);

      } else {
        // console.error("Index out of bounds");
      }
    }
    else {
      if (i >= 0 && i < this.jegeolocationsarray.length) {
        this.jegeolocationsarray.splice(i, 1);

        // Renaming the remaining polygon corner IDs
        for (let j = 0; j < this.jegeolocationsarray.length; j++) {
          for (let k = 0; k < this.jegeolocationsarray[j].length; k++) {
            this.jegeolocationsarray[j][k].CornerID = `Polygon ${j + 1} : Coordinate ${k + 1}`;
          }
        }

        this.onSave(loginType, 0);

      } else {
        // console.error("Index out of bounds");
      }
    }

  }

  onStartNewPolygon(loginType, index) {
    if (loginType == 'xenLogin') {
      this.xengeolocationsarray.push([]);
      this.cdr.detectChanges();
    }
    else if (loginType == 'sdoLogin') {
      this.sdogeolocationsarray.push([]);
      this.cdr.detectChanges();
    }
    else {
      this.jegeolocationsarray.push([]);
      this.cdr.detectChanges();
    }
  }

  onSave(val, tableNo) {
    this.coordinateError = '';
    this.mapEnable = false;
    this.mapEnable = true;
    if (val == 'xenLogin') {
      this.xenMapoptions.center = this.xengeolocationsarray[tableNo][0]
      this.xenMapoverlays = []
      this.xengeolocationsarray.forEach((arr, tableIndex) => {
        arr.forEach((row, index) => {
          this.xenAddMarkers(row, index, tableIndex)
        })
      });
      this.xenAddOverlay()
    } else if (val == 'sdoLogin') {
      this.sdoMapoptions.center = this.sdogeolocationsarray[tableNo][0]
      this.sdoMapoverlays = []
      this.sdogeolocationsarray.forEach((arr, tableIndex) => {
        arr.forEach((row, index) => {
          this.sdoAddMarkers(row, index, tableIndex)
        })
      });
      this.sdoAddOverlay()
    } else {
      this.jeMapoptions.center = this.jegeolocationsarray[tableNo][0]
      this.jeMapoverlays = []
      this.jegeolocationsarray.forEach((arr, tableIndex) => {
        arr.forEach((row, index) => {
          this.addMarkers(row, index, tableIndex)
        })
      });
      this.addOverlay()
    }


    sessionStorage.setItem('miPhysicalAppJEGPSCoordinates', JSON.stringify(this.jegeolocationsarray));
    sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
    sessionStorage.setItem('miPhysicalAppSDOGPSCoordinates', JSON.stringify(this.sdogeolocationsarray));

    // if(this.xenLogin && this.xengeolocationsarray && this.xengeolocationsarray > 3) {

    //   this.verifyCoordinates(this.preEstimateCoordinates, this.xengeolocationsarray, true)
    // } else if(this.jeLogin && this.jegeolocationsarray && this.jegeolocationsarray.length > 0){
    //   let jeArray: any = this.jegeolocationsarray;
    //   const jeMergedArray = jeArray.flat();
    //   let preEstimate: any = this.preEstimateCoordinates;
    //   const preEstimateMerge = preEstimate.flat();

    //   this.verifyCoordinates(preEstimateMerge, jeMergedArray, false)
    //   // this.verifyCoordinates(this.preEstimateCoordinates, this.jegeolocationsarray, false)
    // }
  }

  verifyCoordinates(coordinates1, coordinates2, loginType) {
    let element1coordinatelat = 0
    let element1coordinatelng = 0
    let element2coordinatelat = 0
    let element2coordinatelng = 0
    for (let index = 0; index < coordinates1.length; index++) {
      element1coordinatelat = element1coordinatelat + coordinates1[index].latitude;
      element1coordinatelng = element1coordinatelng + coordinates1[index].longitude;
    }
    for (let index = 0; index < coordinates2.length; index++) {
      element2coordinatelat = element2coordinatelat + coordinates2[index].latitude;
      element2coordinatelng = element2coordinatelng + coordinates2[index].longitude;
    }
    const x1latitude = element1coordinatelat / coordinates1.length
    const y1logitude = element1coordinatelng / coordinates1.length
    const x2latitude = element2coordinatelat / coordinates2.length
    const y2logitude = element2coordinatelng / coordinates2.length
    let distance = this.distance(x1latitude, y1logitude, x2latitude, y2logitude);
    if (!this.preEstimateCoordinates || (this.preEstimateCoordinates && this.preEstimateCoordinates.length == 1 && this.preEstimateCoordinates?.[0]?.length == 0)) {
      sessionStorage.setItem('xencoordinatesVerified', JSON.stringify(true));
      sessionStorage.setItem('sdocoordinatesVerified', JSON.stringify(true));
      sessionStorage.setItem('jecoordinatesVerified', JSON.stringify(true));
      return true
    } else if (distance > 70) {
      if (loginType == 'xenLogin') {
        sessionStorage.setItem('xencoordinatesVerified', JSON.stringify(true));
      } 
      else if (loginType == 'sdoLogin') {
        sessionStorage.setItem('sdocoordinatesVerified', JSON.stringify(true));
      } 
      else {
        sessionStorage.setItem('jecoordinatesVerified', JSON.stringify(true));
      }
      return true
    } else {
      if (loginType == 'xenLogin') {
        sessionStorage.setItem('xencoordinatesVerified', JSON.stringify(false));
      } 
      else if (loginType == 'sdoLogin') {
        sessionStorage.setItem('xencoordinatesVerified', JSON.stringify(false));
      } 
      else {
        sessionStorage.setItem('jecoordinatesVerified', JSON.stringify(false));
      } return false
    }
  }


  distance(lat1, lon1, lat2, lon2) {
    const R = 6371e3; // metres
    const radlat1 = lat1 * Math.PI / 180; // radlat1, radlat2 in radians
    const radlat2 = lat2 * Math.PI / 180;
    const radlon1 = (lat2 - lat1) * Math.PI / 180;
    const radlon2 = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(radlon1 / 2) * Math.sin(radlon1 / 2) +
      Math.cos(radlat1) * Math.cos(radlat2) *
      Math.sin(radlon2 / 2) * Math.sin(radlon2 / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const d = R * c; // in metres
    return d
  }

  setupGeoLocations(data) {
    // data = {
    //   ...data,
    //   listGPSCoordinatesJE : [[]],
    //   listGPSCoordinatesXEN : [[]],
    // }
    this.mapEnableJE = false;
    this.mapEnableXEN = false;
    this.jeMapoverlays = [];
    this.xenMapoverlays = [];
    this.preEstimateCoordinates = data.listGPSCoordinatesPreEst;
    this.jegeolocationsarray = data.listGPSCoordinatesJE;
    this.xengeolocationsarray = data.listGPSCoordinatesXEN;
    this.sdogeolocationsarray = data.listGPSCoordinatesSDO;
    // this.preEstimationGeolocationsArray = data?.listGPSCoordinatesPreEst;


    this.preEstimateCoordinates = this.preEstimateCoordinates.map((array, index) => {
      return array.map((data) => ({
        CornerID: data.CornerID,
        latitude: data.Latitude,
        longitude: data.Longitude,
        lat: data.Latitude,
        lng: data.Longitude,
      }))
    })

    if (data.listGPSCoordinatesJE && data.listGPSCoordinatesJE.length > 0) {
      data.listGPSCoordinatesJE = data.listGPSCoordinatesJE.map((array, tableIndex) => {
        return array.map((val, index) => ({
          latitude: val.Latitude ? val.Latitude : val.latitude,
          longitude: val.Longitude ? val.Longitude : val.longitude,
          lat: val.Latitude ? val.Latitude : val.latitude,
          lng: val.Longitude ? val.Longitude : val.longitude,
          CornerID: val.CornerID ? val.CornerID : val.cornerID,
          cornerID: val.CornerID ? val.CornerID : val.cornerID
        }))
      })

      // for (let index = 0; index < data.listGPSCoordinatesJE.length; index++) {
      //   data.listGPSCoordinatesJE[index].latitude = data.listGPSCoordinatesJE[index].Latitude ? data.listGPSCoordinatesJE[index].Latitude : data.listGPSCoordinatesJE[index].latitude
      //   data.listGPSCoordinatesJE[index].longitude = data.listGPSCoordinatesJE[index].Longitude ? data.listGPSCoordinatesJE[index].Longitude : data.listGPSCoordinatesJE[index].longitude
      //   data.listGPSCoordinatesJE[index].lat = data.listGPSCoordinatesJE[index].latitude
      //   data.listGPSCoordinatesJE[index].lng = data.listGPSCoordinatesJE[index].longitude
      //   data.listGPSCoordinatesJE[index].cornerID = data.listGPSCoordinatesJE[index].CornerID ? data.listGPSCoordinatesJE[index].CornerID : data.listGPSCoordinatesJE[index].cornerID
      // }
      this.jegeolocationsarray = data.listGPSCoordinatesJE
      sessionStorage.setItem('miPhysicalAppJEGPSCoordinates', JSON.stringify(this.jegeolocationsarray));
      // this.verifyCoordinates(this.preEstimateCoordinates, this.jegeolocationsarray, false)
    }

    if (data.listGPSCoordinatesSDO && data.listGPSCoordinatesSDO.length > 0) {
      data.listGPSCoordinatesSDO = data.listGPSCoordinatesSDO.map((array, tableIndex) => {
        return array.map((val, index) => ({
          latitude: val.Latitude ? val.Latitude : val.latitude,
          longitude: val.Longitude ? val.Longitude : val.longitude,
          lat: val.Latitude ? val.Latitude : val.latitude,
          lng: val.Longitude ? val.Longitude : val.longitude,
          CornerID: val.CornerID ? val.CornerID : val.cornerID,
          cornerID: val.CornerID ? val.CornerID : val.cornerID
        }))
      })

      this.sdogeolocationsarray = data.listGPSCoordinatesSDO;
      sessionStorage.setItem('miPhysicalAppSDOGPSCoordinates', JSON.stringify(this.sdogeolocationsarray));
    }

    if (data.listGPSCoordinatesXEN && data.listGPSCoordinatesXEN.length > 0) {
      data.listGPSCoordinatesXEN = data.listGPSCoordinatesXEN.map((array, tableIndex) => {
        return array.map((val, index) => ({
          latitude: val.Latitude ? val.Latitude : val.latitude,
          longitude: val.Longitude ? val.Longitude : val.longitude,
          lat: val.Latitude ? val.Latitude : val.latitude,
          lng: val.Longitude ? val.Longitude : val.longitude,
          CornerID: val.CornerID ? val.CornerID : val.cornerID,
          cornerID: val.CornerID ? val.CornerID : val.cornerID
        }))
      })

      // for (let index = 0; index < data.listGPSCoordinatesXEN.length; index++) {
      //     data.listGPSCoordinatesXEN[index].latitude = data.listGPSCoordinatesXEN[index].Latitude? data.listGPSCoordinatesXEN[index].Latitude : data.listGPSCoordinatesXEN[index].latitude
      //     data.listGPSCoordinatesXEN[index].longitude = data.listGPSCoordinatesXEN[index].Longitude? data.listGPSCoordinatesXEN[index].Longitude : data.listGPSCoordinatesXEN[index].longitude
      //   data.listGPSCoordinatesXEN[index].lat = data.listGPSCoordinatesXEN[index].latitude
      //   data.listGPSCoordinatesXEN[index].lng = data.listGPSCoordinatesXEN[index].longitude
      //     data.listGPSCoordinatesXEN[index].cornerID = data.listGPSCoordinatesXEN[index].CornerID? data.listGPSCoordinatesXEN[index].CornerID : data.listGPSCoordinatesXEN[index].cornerID
      // }
      this.xengeolocationsarray = data.listGPSCoordinatesXEN;
      sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
      // this.verifyCoordinates(this.preEstimateCoordinates, this.xengeolocationsarray, true)
    }


    if (this.preEstimateCoordinates && this.preEstimateCoordinates.length > 0) {
      this.preEstimateMapoptions.center = this.preEstimateCoordinates[0][0]
      this.mapEnable = true;
      this.preEstimateCoordinates.forEach((array, i) => {
        array.forEach((row, index) => {
          this.preEstimationAddMarkers(row, index)
        })
      });
      
      this.preEstimationAddOverlay()
    }

    if (this.jegeolocationsarray && this.jegeolocationsarray?.[0].length > 0) {
      this.mapEnableJE = true;
      this.jeMapoptions.center = this.jegeolocationsarray[0][0];
      this.jeMapoverlays = [];
      this.jegeolocationsarray.forEach((arr, tableIndex) => {
        arr.forEach((row, index) => {
          this.addMarkers(row, index, tableIndex)
        })
      });
      this.addOverlay()
    }

    if (this.sdogeolocationsarray && this.sdogeolocationsarray?.[0].length > 0) {
      this.mapEnableSDO = true;
      this.sdoMapoptions.center = this.sdogeolocationsarray[0][0];
      this.sdoMapoverlays = [];
      this.sdogeolocationsarray.forEach((arr, tableIndex) => {
        arr.forEach((row, index) => {
          this.sdoAddMarkers(row, index, tableIndex)
        })
      });
      this.sdoAddOverlay()
    }

    if (this.xengeolocationsarray && this.xengeolocationsarray?.[0].length > 0) {
      this.mapEnableXEN = true;
      this.xenMapoptions.center = this.xengeolocationsarray[0][0];
      this.xenMapoverlays = [];
      this.xengeolocationsarray.forEach((arr, tableIndex) => {
        arr.forEach((row, index) => {
          this.xenAddMarkers(row, index, tableIndex)
        })
      });
      this.xenAddOverlay()
    }


    // if(this.jegeolocationsarray && this.jegeolocationsarray.length > 0) {
    //   this.jeMapoptions.center = this.jegeolocationsarray[0]
    //   this.mapEnable = true;
    //   this.jegeolocationsarray.forEach((row, index) => {
    //     this.addMarkers(row)
    //   });
    //   this.addOverlay()
    // }

  }

  getSurveyType(event) {
    if ((this.xenLogin || this.sdoLogin) && event == 1) {
      this.basicDetailsForm.controls['cropType'].clearValidators();
      this.basicDetailsForm.controls['cropId'].clearValidators();
      this.basicDetailsForm.controls['cropType'].setValidators(Validators.required);
      this.basicDetailsForm.controls['cropId'].setValidators(Validators.required);

      let val = '';
      if(this.xenLogin){
        val = 'xenLogin'
      }else if(this.sdoLogin){
        val = 'sdoLogin'
      }
      this.refreshLocation = setInterval(() => {
        this.onRefreshCurrentLocation(val);
      }, 5000);
  
    } else {
      if (this.refreshLocation) {
        clearTimeout(this.refreshLocation);
      }
      this.basicDetailsForm.controls['cropType'].clearValidators();
      this.basicDetailsForm.controls['cropId'].clearValidators();
    }
    this.basicDetailsForm.controls['cropType'].updateValueAndValidity();
    this.basicDetailsForm.controls['cropId'].updateValueAndValidity();

    this.selectedSurveyType = event
    sessionStorage.setItem('myPhysicalSurveyType', JSON.stringify(event));
  }

  ngOnDestroy() {
    // sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
    // sessionStorage.setItem('miPhysicalApplicationData', JSON.stringify(data));
    if (this.physicalVerficationApplicationData?.MIArea != this.basicDetailsForm.controls.MIArea.value) {
      sessionStorage.setItem('PVModifiedLandArea', JSON.stringify({ autoId: this.autoId, MIArea: this.basicDetailsForm.controls.MIArea.value }));
      let miPhysicalApplicationData = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));
      if (miPhysicalApplicationData) {
        miPhysicalApplicationData.MIArea = this.basicDetailsForm.controls.MIArea.value;
      }
      sessionStorage.setItem('miPhysicalApplicationData', JSON.stringify(miPhysicalApplicationData));
    }

    let MI_PV_Data = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));
    if (MI_PV_Data) {
      MI_PV_Data.CropTypeId_PV = this.basicDetailsForm.controls.cropType.value;
      MI_PV_Data.CropId_PV = this.basicDetailsForm.controls.cropId.value;
    }
    sessionStorage.setItem('miPhysicalApplicationData', JSON.stringify(MI_PV_Data));

    if (this.refreshLocation) {
      clearTimeout(this.refreshLocation);
    }
  }

  getCorpType() {
    if(sessionStorage.getItem('cropTypeList')) {
      this.cropTypeList = JSON.parse(sessionStorage.getItem('cropTypeList'));
      return;
    }
    
    this.flService
      .GetCorpType()
      .pipe(first())
      .subscribe({
        next: (files) => {
          this.cropTypeList = files;
          sessionStorage.setItem('cropTypeList', JSON.stringify(this.cropTypeList));
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Corp Type Details not loaded.',
          });
        },
      });
  }

  getCropTypeName(event, ...args) {
    const data = this.cropTypeList.find((element) => element.data == event.value);
    if (data) {
      this.cropBasedNames = data.children;
      if (args.length > 0) {
        this.basicDetailsForm.controls.cropId.setValue(args[0]);
      }
    } else {
      this.cropBasedNames = [];
    }
  }

  onSelectRPCase(event) {
    if (this.selectedRPType.length > 0) {
      sessionStorage.setItem('isRPCase', 'true');
    } else {
      sessionStorage.removeItem('isRPCase');
    }
  }

  getApplicationDetails(appId) {
    this.loader.start();
    this.isAppDetails2Loading = true;

    this._dashboardService.getApplicationByAppId(appId)
    .pipe(first())
    .subscribe({
      next: (resp: any) => {
        if(!this.isAppDetails1Loading){
          this.loader.close();
        }
        this.isAppDetails2Loading = false;

        if (resp) {
          this.applicationDetails = resp;

          // this.totalArea = 0;
          if (this.applicationDetails?.New_MI_Datas && this.applicationDetails?.New_MI_Datas.length > 0) {
            this.applicationDetails.New_MI_Datas = this.applicationDetails.New_MI_Datas.filter((val) => {
              return (!(val?.miVendorName == null || val?.miVendorName == '') && !(val?.VendorCode == null && val?.VendorCode == 0))
            });
            // this.applicationDetails.New_MI_Datas.forEach(
            //   (val) => (this.totalArea += parseFloat(val.totalArea))
            // );
          }
        }else {
          this.applicationDetails = null;
          this.messageService.add({ 
            severity: 'error', 
            summary: 'Error Message', 
            detail: `Data error! Application details not loaded` 
          });
        }
      },
      error: (err) => {
        this.applicationDetails = null;
        
        if(!this.isAppDetails1Loading){
          this.loader.close();
        }
        this.isAppDetails2Loading = false;

        this.messageService.add({ 
          severity: 'error', 
          summary: 'Error Message', 
          detail: `Data error! Physical Applications not loaded. ${err}` 
        });
      }
    })
  }

  getExistingMIDetails(appId){ 
    this._dashboardService.getExistingMIDetails(appId)
    .pipe(first())
    .subscribe({
      next: (resp: any) => {
        this.existingMIDetails = resp;
      },
      error: (err) => {
        this.existingMIDetails = null;
      }
    })
  }

  beforeCheckingLandStatus(val){
    this.selLandForOwnerdetails = val;
    this.displayLandOwnerDialog = true;
  }

  startLoadingAnimation(): void {
    this.interval = setInterval(() => {
      this.dotCount = (this.dotCount + 1) % (this.maxDots + 1);
      this.loadingText = `Fetching Owner Details from Land Revenue Department${'.'.repeat(this.dotCount)}`;
    }, 500); // Adjust the interval (in ms) to control the speed of the animation
  }

  stopLoadingAnimation(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  onCloseLandOwnerDialog(){
    this.displayLandOwnerDialog = false;
    this.stopLoadingAnimation();
    this.selLandForOwnerdetails = null;
    this.kewatNo = null;
  
    this.landOwnerDetails = [];
    this.landOwnerDetailsErrorMsg = null;
  }

  submitKewatNo(){
    this.landOwnerDetails = [];
    this.landOwnerDetailsErrorMsg = null;
    if(this.kewatNo){
      this.checkLandStatus(this.selLandForOwnerdetails);
    }
  }

  checkLandStatus(val){
    this.startLoadingAnimation();
    // this.displayLandOwnerDialog = true;
    let reqBody1 = {
      districtCode: val?.R_Dis_Code,
      tehsilCode: val?.R_Teh_Code,
      nvCode: val?.R_Rev_Code,
      khewat: this.kewatNo,
      format: "json",
      farmerId: val?.farmerId
    }

    // let reqBody1 = {
    //   "districtCode": "02",
    //   "tehsilCode": "007",
    //   "nvCode": "01931",
    //   "khewat": this.kewatNo,
    //   "format": "json"
    // }

    // let reqBody2 = {  
    //   "districtCode": "02",  
    //   "tehsilCode": "007",  
    //   "nvCode": "01931",  
    //   "format": "json"
    // }

    // let reqBody2 = {
    //   districtCode: val?.R_Dis_Code,
    //   tehsilCode: val?.R_Teh_Code,
    //   nvCode: val?.R_Rev_Code,
    //   format: "json"
    // }

    this.getLandOwnerDetails(reqBody1);
    // this.getLandKhewatDetails(reqBody2);
  }

  getLandOwnerDetails(reqBody){
    // this.loader.start();
    this.isLandOwnerDetFetching = true;
    this.vendorService 
      .getLandOwnersDetail(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {         
          this.loader.close();
          this.stopLoadingAnimation();
          // this.isLandOwnerDetFetching = false;
          if (resp?.length > 0) {
            this.landOwnerDetails = resp;
            this.landOwnerDetailsErrorMsg = null;

            let reqBody1 = {
              "districtCode": reqBody.districtCode,
              "tehsilCode": reqBody.tehsilCode,
              "nvCode": reqBody?.nvCode,
              "khewat": reqBody?.khewat,
              "format": "json"
            }
            this.getLandGetAreaByKhewat(reqBody)
            this.getKhasraAreaByKhewatNVCode(reqBody1)

          }else{
            this.landOwnerDetails = [];
            this.landOwnerDetailsErrorMsg = `Someting went wrong. Please try again. ${resp}`;;
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data not found',
            });
          }
        },
        error: (err) => {
          this.stopLoadingAnimation();
          this.isLandOwnerDetFetching = false;
          this.showHiddenButton = false;
          this.landOwnerDetailsErrorMsg = `Someting went wrong. Please try again. ${err}`;
          this.landOwnerDetails = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getKhasraAreaByKhewatNVCode(reqBody) {
    // this.loader.start();
    this.vendorService
      .getKhasraAreaKhewatByNVCODE2Khewat(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          if(this.request1complete){
            // this.loader.close();
            this.isLandOwnerDetFetching = false;
          }

          if (resp?.status == 200 && resp?.msg != 'Someting went wrong') {
            this.showHiddenButton = true;
            
            this.landDetailedInfo = JSON.parse(resp?.msg);  
          } else {
            this.showHiddenButton = false;
            this.landDetailedInfo = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Data not found. ${resp?.msg}`,
            });
          }
        },
        error: (err) => {
          this.showHiddenButton = false;
          this.landDetailedInfo = [];
          if(this.request1complete){
            // this.loader.close();
            this.isLandOwnerDetFetching = false;
          }

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        complete: () => {
          this.request2complete = true;
        }
      });
  }

  getLandGetAreaByKhewat(reqBody) {
    // this.loader.start();
    this.vendorService
      .getLandGetAreaByKhewat(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          if(this.request2complete){
            // this.loader.close();
            this.isLandOwnerDetFetching = false;
          }

          if (resp?.status == 200 && resp?.msg != 'Someting went wrong') {
            this.showHiddenButton = true;
            
            const khewatArea = JSON.parse(resp?.msg)[0]?.area;
            const regex = /(\d+)\s*Kanal\s*(\d+)\s*Marla/;
            const values = khewatArea.match(regex);

            const karnal = values[0] ? parseInt(values[1], 10) : 0;
            const marla = values[2] ? parseInt(values[2], 10) : 0;

            this.landOwnerDetails = this.landOwnerDetails.map(val => ({
              ...val,
              khewat_area: khewatArea,
              valKanal: karnal,
              valMarla: marla,
              totalArea_InAcres:  ((karnal * 20) + marla)/20*0.125,
              owner_hissa: ((karnal * 20) + marla)*((val?.Bhag).split('/').map(Number)[0]/(val?.Bhag).split('/').map(Number)[1])/20*0.125,
            }));
          } else {
            this.showHiddenButton = false;
            this.landOwnerDetails = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Data not found. ${resp?.msg}`,
            });
          }
        },
        error: (err) => {
          this.showHiddenButton = false;
          this.landOwnerDetails = [];
          if(this.request1complete){
            // this.loader.close();
            this.isLandOwnerDetFetching = false;
          }

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        complete: () => {
          this.request1complete = true;
        }
      });
  }

}
